import * as _4 from 'lodash4';

export class MyTodosStaffTodosDetailController {
  constructor(private staffTodoID: any) {}
}



// WEBPACK FOOTER //
// ./app/lib/my_todos/views/my_todos_staff_todos_detail/my_todos_staff_todos_detail_controller.ts